export class UserRights {
  addEditDeletePeople: boolean;
  addEditDropDeleteClientPlans: boolean;
  addEditEndClientFees: boolean;
  addEditEndSubsidy: boolean;
  addEditEntities: boolean;
  addEditPortalLogins: boolean;
  addEditQbSpmPlanAssignments: boolean;
  addNote: boolean;
  addVoidPayment: boolean;
  adjustQbInstTypeInfo: boolean;
  canCreateAchTransactionFile: boolean;
  deleteEntities: boolean;
  dropDeleteQbSpmLanAssignments: boolean;
  electQbPlans: boolean;
  runAccountingReports: boolean;
  runStandardReports: boolean;
  runAdminReports: boolean;
  seeFullSsn: boolean;
  updateLetterInsertTab: boolean;
  useAccountUtilities: boolean;
  useAdminUtilities: boolean;
  useExports: boolean;
  useQbSpmProcessTab: boolean;
  useAdminSection: boolean;
  useLettersMenu: boolean;
  useLetterUtilitiesMenu: boolean;
  useClientProcessTab: boolean;
  useMessages: boolean;
  openEnrollmentAddEditDelete: boolean;
  openEnrollmentViewOnly: boolean;
  markLettersAsNotSent: boolean;
  viewMemberPortal: boolean;
}
